/**
 * Generated by orval v7.21.0 🍺
 * Do not edit manually.
 * FastAPI
 * OpenAPI spec version: 0.1.0
 */
import { useMutation } from '@tanstack/react-query'
import type { MutationFunction, UseMutationOptions, UseMutationResult } from '@tanstack/react-query'
import { mutationOptionsWithInteraction } from '../../mutationOptions'
import { customInstance } from '../../mutator'
import type {
  AnchorCheckDTO,
  AnchorCheckPreviewRequestDTO,
  HTTPValidationError,
} from '../fastAPI.schemas'

/**
 * Preview the anchor checks of one support for a draft manual-load sum
and connector selection.

Runs the same product selection as the anchor-check computation
(`compute_anchor_checks`) without persisting anything, so the frontend can show
the would-be anchor and utilization while the manual loads or the Zuganker are
still edited. Supports without connection candidates (columns/rips) return an
empty list.
 * @summary Post Anchor Check Preview
 */
export const postAnchorCheckPreview = (
  projectGuid: string,
  anchorCheckPreviewRequestDTO: AnchorCheckPreviewRequestDTO,
  signal?: AbortSignal,
) => {
  return customInstance<AnchorCheckDTO[]>({
    url: `/projects/${projectGuid}/anchor-check-preview`,
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data: anchorCheckPreviewRequestDTO,
    signal,
  })
}

export const usePostAnchorCheckPreviewMutationOptions = <
  TError = HTTPValidationError,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postAnchorCheckPreview>>,
    TError,
    { projectGuid: string; data: AnchorCheckPreviewRequestDTO },
    TContext
  >
}): UseMutationOptions<
  Awaited<ReturnType<typeof postAnchorCheckPreview>>,
  TError,
  { projectGuid: string; data: AnchorCheckPreviewRequestDTO },
  TContext
> => {
  const mutationKey = ['postAnchorCheckPreview']
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } }

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postAnchorCheckPreview>>,
    { projectGuid: string; data: AnchorCheckPreviewRequestDTO }
  > = props => {
    const { projectGuid, data } = props ?? {}

    return postAnchorCheckPreview(projectGuid, data)
  }

  const customOptions = mutationOptionsWithInteraction(
    { ...mutationOptions, mutationFn },
    { url: `/projects/{projectGuid}/anchor-check-preview` },
    {
      operationId: 'post_anchor_check_preview_projects__project_guid__anchor_check_preview_post',
      operationName: 'postAnchorCheckPreview',
    },
  )

  return customOptions
}

export type PostAnchorCheckPreviewMutationResult = NonNullable<
  Awaited<ReturnType<typeof postAnchorCheckPreview>>
>
export type PostAnchorCheckPreviewMutationBody = AnchorCheckPreviewRequestDTO
export type PostAnchorCheckPreviewMutationError = HTTPValidationError

/**
 * @summary Post Anchor Check Preview
 */
export const usePostAnchorCheckPreview = <
  TError = HTTPValidationError,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postAnchorCheckPreview>>,
    TError,
    { projectGuid: string; data: AnchorCheckPreviewRequestDTO },
    TContext
  >
}): UseMutationResult<
  Awaited<ReturnType<typeof postAnchorCheckPreview>>,
  TError,
  { projectGuid: string; data: AnchorCheckPreviewRequestDTO },
  TContext
> => {
  const mutationOptions = usePostAnchorCheckPreviewMutationOptions(options)

  return useMutation(mutationOptions)
}
